import { form, p, header, h2, address, h, ol, li, div, span, label, hr } from 'react-hyperscript-helpers'
import { TransitionMotion, Motion, spring } from 'react-motion'
const FAST_MOTION = {stiffness: 300, precision: .01, damping: 40}
const FAST_MOTION_STYLE = { entering: spring(0, FAST_MOTION), leaving: spring(0, FAST_MOTION), }
const square = x => x * x
const curve = (b, x) => (1 - b/10) * square(x) + b * x
const ReviewControlsTransition = ({reviewing, mountProgress, pristine, submitting, place, selected_aspect, reset, styles }) =>
	h(TransitionMotion,
		{
			styles: !reviewing ? [] : [{ key: 'child', style: FAST_MOTION_STYLE }],
			willLeave: () => ({ entering: spring(0), leaving: spring(100) }),
			willEnter: () => ({ entering: 100, leaving: 0 }),
		},
		[
			now =>
				div([
					now.map(
						({ style, key }) =>
							mountProgress(style) > 0 &&
							ReviewControls({
								zIndex: mountProgress(style) >= 90 ? 100 : -1,
								key: key,
								left: (mountProgress(style) < 100
											 ? curve(25, mountProgress(style) / 10)
											 : mountProgress(style)) + '%',
								marginLeft: -0.7 * mountProgress(style) / 100 + 'em',
								pristine, submitting, place, selected_aspect, reset,
								styles
							}),
					),
				]),
		],
	 )
const C = classes => {
	if (classes) {
		if (classes.map) {
			return classes.map(cls => C(cls)).join('')
		}
		return '.' + classes.split(' ').join('.')
	}
	return ''
}

import LinkButton from '../../components/Button/LinkButton';
import Button from '../../components/Button/Button';
const ReviewControls = ({key, left, zIndex, marginLeft, pristine, submitting, place, selected_aspect, reset, styles}) =>
	header(C(styles.ReviewControls), { key: key, style: { left, zIndex, marginLeft } }, [
		h(Button, { type: 'submit', disabled: pristine || submitting }, ['Save All']),
		h(LinkButton,
			{
				to: `/place/${place.id}/?aspect=${selected_aspect}`,
				onClick: reset,
				disabled: submitting,
				style: { float: 'right' },
			},
			[pristine ? 'Close' : 'Cancel'],
		 ),
	])

export { ReviewControls, ReviewControlsTransition }



// WEBPACK FOOTER //
// ./src/app/containers/Place/ReviewControls.ts